// Shared catalog of available pagebuilder modules (used for palette + add-module modal)

export const MODULE_CATALOG = [
  // Layout
  { type: 'section', label: 'Sektion', category: 'Layout' },
  { type: 'container', label: 'Container', category: 'Layout' },
  { type: 'card', label: 'Karte', category: 'Layout' },
  { type: 'row', label: 'Zeile (nebeneinander)', category: 'Layout' },
  { type: 'divider', label: 'Trennlinie', category: 'Layout' },
  { type: 'spacer', label: 'Abstand', category: 'Layout' },

  // Inhalte
  { type: 'heading', label: 'Überschrift', category: 'Inhalte' },
  { type: 'text', label: 'Text', category: 'Inhalte' },
  { type: 'button', label: 'Button', category: 'Inhalte' },

  // Medien
  { type: 'banner', label: 'Banner', category: 'Medien' },
  { type: 'image', label: 'Bild', category: 'Medien' },
  { type: 'video', label: 'Video', category: 'Medien' },
  { type: 'companyLogo', label: 'Logo', category: 'Medien' },
  { type: 'companyBrand', label: 'Firma + Adresse', category: 'Medien' },
  { type: 'socials', label: 'Social Media', category: 'Medien' },

  // Spalten/Layout
  { type: 'columns1', label: '1 Spalte', category: 'Spalten' },
  { type: 'columns2', label: '2 Spalten (50/50)', category: 'Spalten' },
  { type: 'columns2_2575', label: '2 Spalten (25/75)', category: 'Spalten' },
  { type: 'columns2_7525', label: '2 Spalten (75/25)', category: 'Spalten' },
  { type: 'columns3', label: '3 Spalten', category: 'Spalten' },
  { type: 'columns3_252550', label: '3 Spalten (25/25/50)', category: 'Spalten' },
  { type: 'columns3_255025', label: '3 Spalten (25/50/25)', category: 'Spalten' },
  { type: 'columns3_502525', label: '3 Spalten (50/25/25)', category: 'Spalten' },
  { type: 'columns4', label: '4 Spalten', category: 'Spalten' },

  // Timer
  { type: 'countdown', label: 'Countdown', category: 'Inhalte' },

  // Formulare (Legacy + Modular)
  { type: 'codeRequestForm', label: 'Formular (Kompakt: E-Mail)', category: 'Formulare' },
  { type: 'codeRequestForm_full', label: 'Formular (Name + Einwilligung)', category: 'Formulare' },
  { type: 'codeRequestGroup', label: 'Formular-Gruppe', category: 'Formulare' },
  { type: 'codeRequestName', label: 'Formularfeld: Name', category: 'Formulare' },
  { type: 'codeRequestEmail', label: 'Formularfeld: E-Mail', category: 'Formulare' },
  { type: 'codeRequestConsent', label: 'Checkbox: Einwilligung', category: 'Formulare' },
  { type: 'codeRequestDropdown', label: 'Formularfeld: Dropdown / Umfrage', category: 'Formulare' },
  { type: 'codeRequestSubmit', label: 'Button: Absenden', category: 'Formulare' },

  // Ergebnis / Anzeige
  { type: 'codeDisplay', label: 'Code-Anzeige', category: 'Ergebnis' },

  // Personalisierung für E-Mails
  { type: 'emailQr', label: 'QR-Code', category: 'Personalisierung' },
  { type: 'claimButton', label: 'Code anzeigen (Button)', category: 'Personalisierung' },
];

const META_BY_TYPE = new Map(MODULE_CATALOG.map(m => [m.type, m]));

export function getModuleMeta(type) {
  return META_BY_TYPE.get(type) || { type, label: type, category: 'Andere' };
}
